import React, { useState } from 'react';
import { Button } from '../ui/button';
import { GitHubLogoIcon } from '@radix-ui/react-icons';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { SourceCodeLinkingForm } from './SourceCodeLinkingForm';

interface LinkSourceCodeButtonProps {
    serviceName: string;
    organizationId?: string;
}

export const LinkSourceCodeButton: React.FC<LinkSourceCodeButtonProps> = ({ serviceName, organizationId }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleSuccess = () => {
        setDialogOpen(false);
        // Optionally refresh the page or update the button state
        window.location.reload();
    };

    return (
        <>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            onClick={() => setDialogOpen(true)}
                            variant="outline"
                            size="sm"
                            className="flex items-center gap-2 border border-border rounded"
                            requiredPermission={{
                                operation: "update",
                                resource: "integrations/default/*"
                            }}
                        >
                            <GitHubLogoIcon className="h-4 w-4" />
                            Link Source Code
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p className="max-w-xs">
                            Link the source code repository for this service. Metoro will use it for enhanced root cause analysis and debugging insights.
                        </p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>

            <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogContent className="sm:max-w-[500px] text-textmedium">
                    <DialogHeader>
                        <DialogTitle>Link Source Code Repository</DialogTitle>
                        <DialogDescription className={"text-textdark"}>
                            Connect your service to its source code repository. This enables Metoro to provide better debugging insights and root cause analysis.
                        </DialogDescription>
                    </DialogHeader>
                    <SourceCodeLinkingForm 
                        serviceName={serviceName}
                        onSuccess={handleSuccess}
                        onCancel={() => setDialogOpen(false)}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};